import { render, staticRenderFns } from "./CopyItemBtn.vue?vue&type=template&id=0055e274&"
import script from "./CopyItemBtn.vue?vue&type=script&lang=js&"
export * from "./CopyItemBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports